import React, { useEffect, useState } from "react";
import { Store, BadgeCheck } from "lucide-react";
import api from "@/lib/api";
import { fileUrl } from "@/lib/uploads";
import { avatarColor, getInitials } from "@/lib/avatar";
import { useI18n } from "@/context/I18nContext";

export default function FeaturedShops({ onOpenShop }) {
  const { t } = useI18n();
  const [shops, setShops] = useState([]);
  useEffect(() => { api.get("/market/shops/featured").then(({ data }) => setShops(data)).catch(() => {}); }, []);
  if (!shops.length) return null;
  return (
    <div className="mb-5" data-testid="featured-shops">
      <div className="flex items-center gap-1.5 mb-2 text-sm font-medium"><Store size={15} className="text-[var(--rc-gold)]" /> {t("m_featured_shops")}</div>
      <div className="flex gap-4 overflow-x-auto no-scrollbar pb-1">
        {shops.map((s) => (
          <button key={s.id} onClick={() => onOpenShop(s.id)} data-testid={`featured-shop-${s.id}`} className="shrink-0 w-16 flex flex-col items-center gap-1">
            <div className="relative h-16 w-16 rounded-full overflow-hidden grid place-items-center border-2 border-[var(--rc-gold)] text-[var(--rc-gold)] font-semibold"
              style={{ backgroundColor: s.avatar ? "var(--rc-bg)" : avatarColor(s.name) }}>
              {s.avatar ? <img src={fileUrl(s.avatar)} alt="" className="h-full w-full object-cover" /> : getInitials(s.name)}
              {s.verified && <span className="absolute -bottom-0.5 -right-0.5 h-5 w-5 grid place-items-center rounded-full bg-[var(--rc-bg)]"><BadgeCheck size={16} className="text-[var(--rc-gold)]" /></span>}
            </div>
            <span className="text-[11px] text-center truncate w-full">{s.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
